
define('text!libs/strand/src/strand-test-form-view/index.html',[],function () { return '<!DOCTYPE html>\n<html>\n\t<head>\n\t\t<script language="javascript" src="../../bower_components/webcomponentsjs/webcomponents-lite.js"></script>\n\t\t<link rel="import" href="strand-test-form-view.html"/>\n\t</head>\n\t<body>\n\t\t<strand-test-form-view></strand-test-form-view>\n\t</body>\n</html>';});

